var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgByUmbra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.327,
    height: 64.001,
    viewBox: "0 0 146.327 64.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-5 {\n        fill: #f1f4f9;\n      }\n\n      .cls-2 {\n        fill: #494949;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #666;\n      }\n\n      .cls-4 {\n        fill: #7a7a7a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "by_umbra",
    transform: "translate(234.07 -5091.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    className: "cls-1",
    d: "M94.809,778.288c0,2.051-1.487,3.289-3.935,3.289H88.289v3.04H87.274v-9.625h3.6c2.449,0,3.935,1.238,3.935,3.3m-1.019,0c0-1.541-1.019-2.413-2.946-2.413H88.287v4.8h2.559c1.927,0,2.946-.881,2.946-2.394",
    transform: "translate(-291.331 4316.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    className: "cls-1",
    d: "M92.356,780.022a3.681,3.681,0,1,1,3.682,3.68,3.68,3.68,0,0,1-3.682-3.68m6.377,0a2.692,2.692,0,1,0-5.379-.236c0,.079,0,.157,0,.236a2.692,2.692,0,1,0,5.379.236c0-.079,0-.157,0-.236",
    transform: "translate(-287.654 4317.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    className: "cls-1",
    d: "M108.811,776.38l-2.739,7.239h-.922l-2.284-5.929-2.284,5.927h-.922l-2.723-7.239h.936l2.27,6.15,2.325-6.15h.839l2.311,6.15,2.3-6.148Z",
    transform: "translate(-284.339 4317.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    className: "cls-1",
    d: "M111.172,780.323h-6.055a2.679,2.679,0,0,0,2.828,2.52l.021,0a2.85,2.85,0,0,0,2.215-.95l.552.633a3.826,3.826,0,0,1-6.591-2.5,3.485,3.485,0,0,1,3.3-3.668c.079-.005.16-.007.24-.005a3.448,3.448,0,0,1,3.516,3.376c0,.1,0,.2-.007.3,0,.083-.014.193-.014.3m-6.055-.726h5.131a2.572,2.572,0,0,0-5.131,0",
    transform: "translate(-279.131 4317.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    className: "cls-1",
    d: "M113.028,776.353v.95c-.083,0-.172-.014-.233-.014a2.343,2.343,0,0,0-2.458,2.218,2.46,2.46,0,0,0,.021.45v3.688h-.977v-7.239h.936v1.417a2.728,2.728,0,0,1,2.709-1.472",
    transform: "translate(-275.336 4317.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    className: "cls-1",
    d: "M119.09,780.323h-6.053a2.677,2.677,0,0,0,2.825,2.52l.022,0a2.85,2.85,0,0,0,2.215-.95l.552.633a3.826,3.826,0,0,1-6.591-2.5,3.485,3.485,0,0,1,3.3-3.668c.079-.005.16-.007.24-.005a3.448,3.448,0,0,1,3.516,3.376c0,.1,0,.2-.007.3,0,.083-.014.193-.014.3m-6.055-.726h5.131a2.57,2.57,0,0,0-5.131,0",
    transform: "translate(-273.402 4317.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    className: "cls-1",
    d: "M124.214,774.654v10.209h-.936v-1.431a3.134,3.134,0,0,1-2.794,1.5,3.512,3.512,0,0,1-3.607-3.416c0-.09,0-.181,0-.272a3.5,3.5,0,0,1,3.326-3.669c.091-.005.184-.007.277,0A3.159,3.159,0,0,1,123.242,779v-4.349Zm-.963,6.591a2.692,2.692,0,1,0-5.379-.236c0,.079,0,.157,0,.236a2.692,2.692,0,0,0,5.379.236c0-.079,0-.157,0-.236",
    transform: "translate(-269.913 4316.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    className: "cls-1",
    d: "M132.138,781.245a3.513,3.513,0,0,1-3.332,3.685c-.09.005-.181.005-.272,0a3.134,3.134,0,0,1-2.794-1.5v1.431H124.8v-10.21h.977V779a3.163,3.163,0,0,1,2.758-1.432,3.5,3.5,0,0,1,3.607,3.392c0,.093,0,.188,0,.281m-.977,0a2.7,2.7,0,0,0-5.393-.236c0,.079,0,.157,0,.236a2.7,2.7,0,0,0,5.393.236c0-.079,0-.157,0-.236",
    transform: "translate(-264.176 4316.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    className: "cls-1",
    d: "M136.9,776.379l-3.62,8.1c-.607,1.417-1.379,1.872-2.413,1.872a2.483,2.483,0,0,1-1.761-.662l.453-.729a1.8,1.8,0,0,0,1.322.552c.646,0,1.086-.3,1.5-1.206l.317-.7-3.233-7.223h1.019l2.725,6.15,2.725-6.15Z",
    transform: "translate(-261.066 4317.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    className: "cls-1",
    d: "M163.366,813.691,154.419,794.1a.345.345,0,0,0-.345-.2h-1.913a.345.345,0,0,0-.345.2l-8.975,19.588c-.086.2,0,.345.2.345h4.037a.306.306,0,0,0,.31-.2l1.1-2.332.009-.021,2.258-5.06v-.014l.009-.024.148-.331,2-4.44a.206.206,0,0,1,.253-.141.2.2,0,0,1,.141.141l2.117,4.771c.084.2,0,.345-.2.345h-3.039l-1.867,4.212h6.894a.307.307,0,0,1,.31.2l1.27,2.682a.345.345,0,0,0,.345.2h4.037c.2,0,.283-.141.2-.345",
    transform: "translate(-251.149 4330.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    className: "cls-1",
    d: "M106.623,797.481v14.031h4.812v-6.675Z",
    transform: "translate(-277.331 4333.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    className: "cls-1",
    d: "M127.551,793.91V814.1h-4.816v-8.635c0-.255-.2-.345-.345-.141l-5.029,7.334-.036.05a.333.333,0,0,1-.51,0l-.045-.064-4.093-5.977-.048-.071L109.94,802.5l-3.32-5.1v-3.49h2.6a.384.384,0,0,1,.367.172l7.2,11.062a.34.34,0,0,0,.276.148.332.332,0,0,0,.277-.145l7.23-11.065a.387.387,0,0,1,.369-.172Z",
    transform: "translate(-277.333 4330.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    className: "cls-1",
    d: "M134.327,803.7c-.2-.114-.2-.2-.029-.312a4.356,4.356,0,0,0,1.672-3.62c0-3.711-2.208-5.833-6.288-5.833h-8.125v20.183h8.973c4.078,0,6.288-2.122,6.288-5.832a5,5,0,0,0-2.491-4.586m-3.792,6.172h-3.876a.268.268,0,0,1-.284-.248V798.46a.266.266,0,0,1,.252-.281h3.061a1.9,1.9,0,0,1,2.034,1.748q.005.06.005.119a1.871,1.871,0,0,1-1.9,1.848c-.047,0-.095,0-.143-.007h-1.875v4.247h2.723a1.875,1.875,0,1,1,.3,3.738,1.733,1.733,0,0,1-.3,0",
    transform: "translate(-266.526 4330.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    className: "cls-1",
    d: "M145.428,807.5a.279.279,0,0,1,.071-.388l.016-.01a6.814,6.814,0,0,0,3.447-6.058,7.107,7.107,0,0,0-7.106-7.11c-.076,0-.15,0-.226,0h-8.921v20.188h4.812V798.176h3.542a2.866,2.866,0,1,1,0,5.717h-1.9a.374.374,0,0,0-.374.371.367.367,0,0,0,.041.171l2.69,5.29.033.065,2.117,4.137a.345.345,0,0,0,.345.2h4.573c.2,0,.312-.143.2-.345Z",
    transform: "translate(-258.457 4330.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    className: "cls-1",
    d: "M111.764,793.909h-4.533V805.4c-.083,3.173-1.643,4.53-4.137,4.53-2.549,0-4.161-1.379-4.161-4.53V793.915H94.118V805.4c0,3.792,1.784,8.778,8.976,8.778,7.163,0,8.947-4.984,8.947-8.778v-11.5Z",
    transform: "translate(-286.379 4330.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    className: "cls-1",
    d: "M94.689,813.543H94.21a.077.077,0,0,1-.079-.073v-5.548a.077.077,0,0,1,.072-.079h.486a.077.077,0,0,1,.079.072v5.548a.077.077,0,0,1-.072.079h-.007",
    transform: "translate(-286.37 4340.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    className: "cls-1",
    d: "M102.982,813.543h-.345a.114.114,0,0,1-.1-.048l-3.2-4.333c-.057-.072-.1-.033-.1.04v4.261a.077.077,0,0,1-.072.079h-.486a.076.076,0,0,1-.079-.072v-5.546a.077.077,0,0,1,.072-.079h.343a.114.114,0,0,1,.1.048l3.206,4.333c.057.072.1.033.1-.04v-4.262a.077.077,0,0,1,.072-.079h.486a.077.077,0,0,1,.079.072v5.548a.077.077,0,0,1-.072.079h-.007",
    transform: "translate(-283.13 4340.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    className: "cls-1",
    d: "M108.805,807.919v.419a.076.076,0,0,1-.072.079h-1.422a.077.077,0,0,0-.081.071v4.967a.077.077,0,0,1-.072.079h-.486a.077.077,0,0,1-.079-.072v-4.952a.077.077,0,0,0-.071-.081h-1.432a.077.077,0,0,1-.079-.072v-.431a.077.077,0,0,1,.072-.079h3.645a.077.077,0,0,1,.079.072v.007",
    transform: "translate(-278.498 4340.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    className: "cls-1",
    d: "M114.37,813.039v.424a.077.077,0,0,1-.072.079h-3.14a.076.076,0,0,1-.081-.071v-5.55a.077.077,0,0,1,.072-.079h3.063a.077.077,0,0,1,.081.071v.429a.076.076,0,0,1-.072.079H111.8a.077.077,0,0,0-.079.072v1.9a.077.077,0,0,0,.071.081h1.744a.077.077,0,0,1,.081.071v.433a.077.077,0,0,1-.072.079H111.8a.077.077,0,0,0-.079.073v1.751a.077.077,0,0,0,.071.081h2.5a.077.077,0,0,1,.079.072v.007",
    transform: "translate(-274.109 4340.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    className: "cls-1",
    d: "M116.868,813.463v-5.54a.077.077,0,0,1,.071-.081h2.077a1.877,1.877,0,0,1,.936,3.551.078.078,0,0,0-.028.107l0,.005,1.007,1.943c.033.057,0,.1-.055.1h-.527a.105.105,0,0,1-.1-.057l-.936-1.839a.1.1,0,0,0-.1-.057h-1.63a.076.076,0,0,0-.081.071v1.8a.077.077,0,0,1-.071.081h-.488a.077.077,0,0,1-.079-.073v-.009M119.114,811a1.257,1.257,0,0,0,1.224-1.287,1.235,1.235,0,0,0-1.379-1.287h-1.367a.077.077,0,0,0-.081.071v2.422a.077.077,0,0,0,.072.079h.009Z",
    transform: "translate(-269.918 4340.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    className: "cls-1",
    d: "M125.386,807.842h.279a.1.1,0,0,1,.1.055l2.351,5.548c.024.055,0,.1-.057.1h-.472a.1.1,0,0,1-.1-.057l-.5-1.182a.088.088,0,0,0-.088-.057h-2.744a.1.1,0,0,0-.1.057l-.5,1.182a.086.086,0,0,1-.088.057h-.472c-.057,0-.079-.04-.057-.1l2.351-5.548a.1.1,0,0,1,.1-.055m-.96,3.814h2.2c.057,0,.079-.04.057-.1l-1.1-2.63a.058.058,0,0,0-.112,0l-1.1,2.63c-.024.055,0,.1.057.1",
    transform: "translate(-265.534 4340.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    className: "cls-1",
    d: "M133.837,811.99l.455.064c.048,0,.04.064.033.1a2.4,2.4,0,0,1-2.241,1.424,2.882,2.882,0,0,1,0-5.757,2.415,2.415,0,0,1,2.241,1.431c0,.04.033.088-.033.1l-.455.064c-.048,0-.088.024-.112-.033a1.882,1.882,0,0,0-1.663-.967,2.3,2.3,0,0,0,0,4.581,1.9,1.9,0,0,0,1.663-.976c.024-.057.072-.04.112-.033",
    transform: "translate(-260.891 4340.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    className: "cls-1",
    d: "M139.719,807.919v.419a.076.076,0,0,1-.072.079h-1.422a.077.077,0,0,0-.081.071v4.967a.077.077,0,0,1-.072.079h-.486a.077.077,0,0,1-.079-.072v-4.952a.077.077,0,0,0-.071-.081H136a.077.077,0,0,1-.079-.072v-.431a.077.077,0,0,1,.072-.079h3.645a.077.077,0,0,1,.079.072v.007",
    transform: "translate(-256.13 4340.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    className: "cls-1",
    d: "M142.593,813.543h-.477a.077.077,0,0,1-.079-.073v-5.548a.077.077,0,0,1,.072-.079h.486a.077.077,0,0,1,.079.072v5.548a.077.077,0,0,1-.072.079h-.007",
    transform: "translate(-251.708 4340.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    className: "cls-1",
    d: "M148.836,813.544h-.279a.1.1,0,0,1-.1-.057l-2.241-5.548c-.024-.057,0-.1.057-.1h.488a.086.086,0,0,1,.088.055l1.791,4.566c.033.057.088.057.112,0l1.791-4.566a.086.086,0,0,1,.088-.055h.488c.057,0,.081.04.057.1l-2.241,5.548a.1.1,0,0,1-.1.057",
    transform: "translate(-248.687 4340.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    className: "cls-1",
    d: "M156.13,813.039v.424a.077.077,0,0,1-.072.079h-3.14a.076.076,0,0,1-.081-.071v-5.55a.077.077,0,0,1,.072-.079h3.063a.077.077,0,0,1,.081.071v.429a.076.076,0,0,1-.072.079h-2.422a.077.077,0,0,0-.079.072v1.9a.077.077,0,0,0,.071.081h1.743a.077.077,0,0,1,.081.071v.433a.077.077,0,0,1-.072.079h-1.743a.077.077,0,0,0-.079.073v1.751a.077.077,0,0,0,.071.081h2.5a.077.077,0,0,1,.079.072v.007",
    transform: "translate(-243.893 4340.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    className: "cls-2",
    d: "M87.7,804.354v20.121a2.7,2.7,0,0,1-1.343-.362L71.2,815.375a2.7,2.7,0,0,1-1.343-2.2V795.349a2.7,2.7,0,0,1,.329-1.1l8.59,4.967Z",
    transform: "translate(-303.931 4330.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    className: "cls-3",
    d: "M86.446,798.02v6.351a6.251,6.251,0,0,1-6.234,6.225V801.62Z",
    transform: "translate(-296.441 4333.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    className: "cls-3",
    d: "M98.047,795.407v17.837a2.687,2.687,0,0,1-1.339,2.125l-15.145,8.744a2.7,2.7,0,0,1-1.353.362v-5.612A11.744,11.744,0,0,0,91.841,807.1v-9.462l5.876-3.387a2.71,2.71,0,0,1,.329,1.158",
    transform: "translate(-296.443 4330.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    className: "cls-4",
    d: "M105.064,798.487l-8.59,4.953-8.918,5.146-8.916-5.15-8.585-4.96a2.742,2.742,0,0,1,.572-.71L86.3,788.73a2.528,2.528,0,0,1,2.528,0l15.684,9.061a2.683,2.683,0,0,1,.557.7",
    transform: "translate(-303.79 4326.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    className: "cls-1",
    d: "M80.229,797.22l-3.164-1.827,5.427-3.1,5.4,3.12-2.7,1.568L82.5,798.53Z",
    transform: "translate(-298.718 4329.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    className: "cls-5",
    d: "M94.179,795.363l-2.566,1.465-2.87,1.641,2.563,1.484h.016v6.377a6.231,6.231,0,0,1-12.461-.021v-6.377h.016l2.563-1.484-2.87-1.641L76,795.342l-2.527,1.472h-.014v9.518a11.72,11.72,0,0,0,11.444,11.748h.324A11.7,11.7,0,0,0,96.72,806.373v-9.526Z",
    transform: "translate(-301.325 4331.516)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgByUmbra);
export default __webpack_public_path__ + "static/media/by_umbra.2e071342079ef5e58a110dce286c3271.svg";
export { ForwardRef as ReactComponent };